import { Swiper, Navigation, Pagination, Drift } from "@hh/global.js";
class ProductMedia extends HTMLElement {
    constructor() {
        super(),
            Swiper.use([Navigation]),
            Swiper.use([Pagination]),
            (this.swiperSlider = new Swiper(this.querySelector(".js-slider"), {
                lazy: !0,
                navigation: { nextEl: this.querySelector(".js-next"), prevEl: this.querySelector(".js-prev") },
                pagination: { el: this.querySelector(".swiper-pagination"), clickable: !0 },
            })),
            (this.swiperThumbnailSlider = new Swiper(this.querySelector(".js-thumbnail-slider"), {
                direction: "vertical",
                slidesPerView: 5,
                spaceBetween: 20,
                navigation: {
                    nextEl: this.querySelector(".js-thumbnail-next"),
                    prevEl: this.querySelector(".js-thumbnail-prev"),
                },
            })),
            this.swiperSlider.on("transitionEnd", () => {
                const index = this.swiperSlider.realIndex;
                this.onSliderChange(this.swiperSlider.realIndex);
                this.onSliderChange(index);
                this.swiperThumbnailSlider.slideTo(index); 
            }),
            (this.mainImages = this.querySelectorAll(".js-media-main-item")),
            (this.thumbImages = this.querySelectorAll(".js-media-thumbnail-item")),
            this.addEventListener("SWATCH_IMAGES_CHANGE", this.onSwatchImagesChanged.bind(this)),
            this.thumbImages.forEach((e) => {
                e.addEventListener("click", () => {
                    this.onThumbnailClicked(e);
                });
            });
        const e = window.matchMedia("(min-width: 1024px)").matches;
        this.mainImages.forEach((i) => {
            !i.classList.contains("js-video-item") &&
                e &&
                (this.imageDrift = new Drift(i, {
                    paneContainer: this.querySelector(".js-media-item-zoom"),
                    hoverBoundingBox: !0,
                    boundingBoxContainer: this.querySelector(".js-media-item-zoom-box"),
                    zoomFactor: 3,
                    onShow: () => this.onZoomShow(),
                    onHide: () => this.onZoomHide(),
                }));
        }),
            this.adjustZoomBox(),
            window.addEventListener("resize", () => {
                this.adjustZoomBox();
            }),
            this.activeThumbs.length > 5
                ? (this.querySelector(".js-thumbnail-next").classList.remove("hidden"),
                  this.querySelector(".js-thumbnail-prev").classList.remove("hidden"))
                : (this.querySelector(".js-thumbnail-next").classList.add("hidden"),
                  this.querySelector(".js-thumbnail-prev").classList.add("hidden"));
    }
    onZoomHide() {
        this.querySelectorAll(".js-media-item-zoom, .js-media-item-zoom-box").forEach((e) =>
            e.classList.add("disabled")
        );
    }
    onZoomShow() {
        this.querySelectorAll(".js-media-item-zoom, .js-media-item-zoom-box").forEach((e) =>
            e.classList.remove("disabled")
        );
    }
    adjustZoomBox() {
        const e = this.querySelector(".js-media-item-zoom-box"),
            i = e.getBoundingClientRect();
        e.style.setProperty("--hh-margin-top", 0 - i.top + "px"),
            e.style.setProperty("--hh-margin-left", 0 - i.left + "px");
    }
    onSwatchImagesChanged(e) {
        const position = e.detail.imagePosition ?? 0;

        this.swiperSlider.updateSlides(),
        this.swiperThumbnailSlider.updateSlides(),
        this.swiperSlider.slideTo(position),
        this.swiperThumbnailSlider.slideTo(position);
        this.onSliderChange(position);
    }
    onThumbnailClicked(e) {
        const i = this.activeThumbs.indexOf(e);
        i > -1 && this.swiperSlider && this.swiperSlider.slideTo(i);
    }
    onSliderChange(e) {
        this.activeThumbs.forEach((i, t) => {
            t == e ? i.classList.add("active") : i.classList.remove("active");
        });
    }
    get activeThumbs() {
        return Array.from(document.querySelectorAll(".js-media-thumbnail-item:not(.hidden)")) ?? [];
    }
}
customElements.define("hh-product-media", ProductMedia);
